<template>
	<div>
		<b-card no-body class="mb-0">
			<div class="m-2">
				<b-row>
					<b-col cols="12">
						<h4 class="mb-0">Catálogos de Maestros de Datos</h4>
						<small class="text-muted">
							Gestione los listados de departamentos, cargos, ubicaciones y áreas de negocio.
						</small>
					</b-col>
				</b-row>
			</div>

			<b-table
				class="position-relative"
				:items="catalogs"
				:fields="tableFields"
				:busy="isLoading"
				responsive
				show-empty
				empty-text="No se encontraron catálogos"
				bordered
			>
				<template #table-busy>
					<div class="text-center text-primary my-2">
						<b-spinner class="align-middle mb-1"></b-spinner>
						<div>
							<b>CARGANDO</b>
						</div>
					</div>
				</template>

				<template #cell(label)="data">
					<strong>{{ data.item.label }}</strong>
				</template>

				<template #cell(count)="data">
					<b-badge variant="light-primary" pill>
						{{ data.item.count }}
					</b-badge>
				</template>

				<template #cell(last_updated_by)="data">
					<span>{{ data.item.last_updated_by || '-' }}</span>
				</template>

				<template #cell(last_updated_at)="data">
					<span class="text-nowrap">{{ formatStringToDate(data.item.last_updated_at) }}</span>
				</template>

				<template #cell(actions)="data">
					<b-button
						variant="flat-primary"
						class="btn-icon"
						size="sm"
						v-b-tooltip.hover
						title="Abrir registros"
						@click="openCatalog(data.item.slug)"
					>
						<feather-icon icon="ListIcon" />
					</b-button>
				</template>
			</b-table>
		</b-card>
	</div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "@vue/composition-api"
import { VBTooltip } from "bootstrap-vue"
import { formatStringToDate } from "@core/utils/filter"
import useNotifications from "@notifications"
import masterDataStoreModule from "../masterDataStoreModule"
import store from "@/store"
import router from "@/router"

export default {
	directives: {
		"b-tooltip": VBTooltip
	},
	setup() {
		const { toastNotification } = useNotifications()

		const STORE_NAME = "app-master-data"

		if (!store.hasModule(STORE_NAME))
			store.registerModule(STORE_NAME, masterDataStoreModule)

		onUnmounted(() => {
			if (store.hasModule(STORE_NAME))
				store.unregisterModule(STORE_NAME)
		})

		const catalogs = ref([])
		const isLoading = ref(false)

		const tableFields = [
			{ key: "label", label: "Catálogo", thClass: "text-center", tdClass: "align-middle" },
			{ key: "count", label: "Cantidad de registros", thClass: "text-center", tdClass: "text-center align-middle", thStyle: { width: "20%" } },
			{ key: "last_updated_by", label: "Último usuario", thClass: "text-center", tdClass: "text-center align-middle", thStyle: { width: "25%" } },
			{ key: "last_updated_at", label: "Última actualización", thClass: "text-center", tdClass: "text-center align-middle", thStyle: { width: "20%" } },
			{ key: "actions", label: "Acción", thClass: "text-center", tdClass: "text-center align-middle", thStyle: { width: "10%" } }
		]

		const fetchCatalogs = async () => {
			isLoading.value = true
			try {
				const response = await store.dispatch(`${STORE_NAME}/fetchCatalogs`)
				catalogs.value = response.data.items || []
			} catch (error) {
				toastNotification(error.response?.data?.message || "Error al cargar catálogos", false)
			} finally {
				isLoading.value = false
			}
		}

		const openCatalog = (slug) => {
			router.push({ name: "master-data-detail", params: { catalog: slug } })
		}

		onMounted(fetchCatalogs)

		return {
			catalogs,
			isLoading,
			tableFields,
			openCatalog,
			formatStringToDate
		}
	}
}
</script>
